import { Link } from 'react-router-dom';

const Logo = ({ height = 60 }) => {
  return (
    <Link to="/" style={{ display: 'inline-block' }}>
      <img
        src="https://www.remora.com.tr/wp-content/uploads/2025/05/logo.png"
        alt="Logo"
        style={{ height: `${height}px`, width: 'auto', cursor: 'pointer' }}
      />
    </Link>
  );
};

export default Logo;
